import {useDispatch, useSelector} from 'react-redux'
import type {RootState} from '@/store'
import AccordionWrapper from '@/components/GDS/molecules/AccordionWrapper/AccordionWrapper'
import ReviewChildSection from './ReviewChildSection'
import {MAIN_POPUP_STEPS, TEAM_STEP_ONE} from '../../util/constants'

import styles from './ReviewStep.module.css'
import sharedStyles from '@/components/SelfOnboarding/Shared/OnboardingFormShared.module.css'
import {Icon, Label} from 'pepsico-ds'
import ButtonWrapper from '@/components/GDS/molecules/Button/Button'
import {setOldProgramReference} from '@/store/programOnboardingSlice'
interface ReviewStepProps {
  onEditStep: (stepIndex: number) => void
}

const ReviewStep: React.FC<ReviewStepProps> = ({onEditStep}) => {
  // Fetch all onboarding details from Redux
  const onboardingDashboard = useSelector((state: RootState) => state.onboardingDashboard)
  const repos = useSelector((state: RootState) => state.repo)
  const build = useSelector((state: RootState) => state.build)
  const deploy = useSelector((state: RootState) => state.deploy)
  const qa = useSelector((state: RootState) => state.qa)
  const security = useSelector((state: RootState) => state.security)
  const appsec = useSelector((state: RootState) => state.appsec)
  const feature = useSelector((state: RootState) => state.feature)
  const dispatch = useDispatch()

  const linkedDashboard = onboardingDashboard?.programDashboardName || '-'

  return (
    <>
      <div className={styles.sectionContainer}>
        <div className={styles.sectionHeadingContainer}>
          <div className={styles.sectionHeading}>
            <Label label={MAIN_POPUP_STEPS[0]} />
          </div>
          <Icon
            alt="alt value"
            className="edit-icon"
            icon="edit"
            size="medium"
            style={{
              color: '#005CBC',
            }}
            onClick={() => onEditStep(0)}
          />
        </div>
        <div className={styles.contentGroupContainer}>
          <div className={styles.contentGroup}>
            <div className={styles.rowMetaData}>{TEAM_STEP_ONE.teamName}</div>
            <div className={styles.rowData}>{onboardingDashboard?.dashboard?.title || '-'}</div>
          </div>
          <div className={styles.contentGroup}>
            <div className={styles.rowMetaData}>{TEAM_STEP_ONE.ownerName || 'Application owner(s)'}</div>
            <div className={styles.rowData}>
              {onboardingDashboard?.dashboard?.owners
                ? onboardingDashboard.dashboard?.owners.map((o: any) => o.ownerName).join(', ')
                : onboardingDashboard?.dashboard?.teamInfo?.teamName || '-'}
            </div>
          </div>
          <div className={styles.contentGroup}>
            <div className={styles.rowMetaData}>{TEAM_STEP_ONE.ownerEmail}</div>
            <div className={styles.rowData}>
              {onboardingDashboard?.dashboard?.owners
                ? onboardingDashboard.dashboard?.owners.map((o: any) => o.emails).join(', ')
                : '-'}
            </div>
          </div>
        </div>
      </div>
      <div className={sharedStyles.divider} />
      <div className={styles.sectionContainer}>
        <div className={styles.sectionHeadingContainer}>
          <div className={styles.sectionHeading}>
            <Label label="Section Details" />
          </div>
          <Icon
            alt="alt value"
            className="edit-icon"
            icon="edit"
            size="medium"
            style={{
              color: '#005CBC',
            }}
            onClick={() => onEditStep(1)}
          />
        </div>
        <div className={styles.contentGroupContainer}>
          <AccordionWrapper
            presentation="no-background"
            separator={true}
            items={[
              {
                label: 'Code Repo',
                presentation: 'no-background',
                rightAccessoryChild: (
                  <ButtonWrapper variant="tertiary" size="small" onClick={() => function oFe() {}} />
                ),
                children: <ReviewChildSection type="repo" data={repos || []} />,
              },
              {
                label: 'Build',
                presentation: 'no-background',
                rightAccessoryChild: (
                  <ButtonWrapper variant="tertiary" size="small" onClick={() => function oFe() {}} />
                ),
                children: (
                  <ReviewChildSection
                    type="build"
                    data={build.pipelines || []}
                    buildDurationThreshold={build?.buildDurationThreshold}
                  />
                ),
              },
              {
                label: 'Deploy',
                presentation: 'no-background',
                rightAccessoryChild: (
                  <ButtonWrapper variant="tertiary" size="small" onClick={() => function oFe() {}} />
                ),
                children: <ReviewChildSection type="deploy" data={deploy || []} />,
              },
              {
                label: 'QA Metrics',
                presentation: 'no-background',
                rightAccessoryChild: (
                  <ButtonWrapper variant="tertiary" size="small" onClick={() => function oFe() {}} />
                ),
                children: <ReviewChildSection type="qa" data={qa || []} />,
              },
              {
                label: 'Security Analysis',
                presentation: 'no-background',
                rightAccessoryChild: (
                  <ButtonWrapper variant="tertiary" size="small" onClick={() => function oFe() {}} />
                ),
                children: <ReviewChildSection type="appsec" data={appsec || []} />,
              },
              {
                label: 'Code Analysis',
                presentation: 'no-background',
                rightAccessoryChild: (
                  <ButtonWrapper variant="tertiary" size="small" onClick={() => function oFe() {}} />
                ),
                children: <ReviewChildSection type="security" data={security || []} />,
              },
              {
                label: 'Features',
                presentation: 'no-background',
                rightAccessoryChild: (
                  <ButtonWrapper variant="tertiary" size="small" onClick={() => function oFe() {}} />
                ),
                children: <ReviewChildSection type="feature" data={feature || []} />,
              },
            ]}
          />
        </div>
      </div>
      <div className={styles.divider} />
      <div className={styles.sectionContainer}>
        <div className={styles.sectionHeadingContainer}>
          <div className={styles.sectionHeading}>
            <Label label="Linked Program Dashboard" />
          </div>
          <Icon
            alt="alt value"
            className="edit-icon"
            icon="edit"
            size="medium"
            style={{
              color: '#005CBC',
            }}
            onClick={() => {
              dispatch(setOldProgramReference({oldProductId: undefined, linkAction: 'TRANSFER'}))
              onEditStep(2)
            }}
          />
        </div>
        <div className={styles.contentGroupContainer}>
          <div className={styles.contentGroup}>
            <div className={styles.rowMetaData}>Program Dashboard</div>
            <div className={styles.rowData}>{linkedDashboard || '-'}</div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ReviewStep
